// @unocss-include
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from '@a-type/ui';
export function Price(_a) {
    var _b, _c;
    var { value, currency, period = 'month', className } = _a, rest = __rest(_a, ["value", "currency", "period", "className"]);
    const currencySymbol = (_c = currencySymbols[(_b = currency === null || currency === void 0 ? void 0 : currency.toUpperCase()) !== null && _b !== void 0 ? _b : 'USD']) !== null && _c !== void 0 ? _c : '$';
    return (_jsxs("span", Object.assign({ className: clsx('font-bold text-nowrap', className) }, rest, { children: [currencySymbol, ((value !== null && value !== void 0 ? value : 0) / 100).toFixed(2), " / ", period] })));
}
const currencySymbols = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    YEN: '¥',
    INR: '₹',
    AUD: 'A$',
    CAD: 'C$',
    CHF: 'CHF',
    SEK: 'kr',
    NZD: 'NZ$',
};
//# sourceMappingURL=Price.js.map